"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Chat_1 = __importDefault(require("@mui/icons-material/Chat"));
const ChatBubbleOutline_1 = __importDefault(require("@mui/icons-material/ChatBubbleOutline"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const styles = ({ components }) => ({
    buttonRoot: {
        outline: 'none !important',
        fontSize: 'unset',
        padding: components.navigation.iconVerticalSpacing,
        color: components.navigation.iconColor,
        opacity: components.navigation.rowOpacity,
        justifyContent: 'unset',
    },
});
const useStyle = (0, mui_1.makeStyles)()(styles);
const QCardToggleButton = ({ size, qCardsOn, closeHeader, onClick }) => {
    const { classes } = useStyle();
    const QCardIcon = qCardsOn ? Chat_1.default : ChatBubbleOutline_1.default;
    return (<QTip_1.default placement="right" title={`QCards are currently ${qCardsOn ? 'on' : 'off'}`}>
      <IconButton_1.default id={qCardsOn ? 'qCardsTrue' : 'qCardsFalse'} aria-label="QCard Toggle" classes={{
            root: classes.buttonRoot,
        }} onClick={(e) => {
            closeHeader();
            onClick(!qCardsOn);
            e.stopPropagation();
        }} size="large">
        <QCardIcon style={{ fontSize: size }}/>
      </IconButton_1.default>
    </QTip_1.default>);
};
exports.default = QCardToggleButton;
